var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9875 5H5.52502C5.23506 5 5 5.24649 5 5.55054V14.4245C5 14.7285 5.23498 14.975 5.52502 14.975H10.0814V11.1175H8.84589V9.60759H10.0814V8.49645C10.0814 7.20806 10.8318 6.5065 11.9278 6.5065C12.4528 6.5065 12.904 6.54749 13.0355 6.56581V7.91226L12.2796 7.91262C11.6832 7.91262 11.5677 8.20981 11.5677 8.64591V9.60759H12.9936L12.8079 11.1175H11.5677V14.975H13.9875C14.2775 14.975 14.5125 14.7285 14.5125 14.4245V5.55054C14.5125 5.24649 14.2775 5 13.9875 5",
    fill: "#47494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/Social_facebook.982bb2989e8c9406e6b9494841c647bb.svg";
export { ForwardRef as ReactComponent };